import { render, staticRenderFns } from "./InputTp.vue?vue&type=template&id=236f845c"
import script from "./InputTp.vue?vue&type=script&lang=js"
export * from "./InputTp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports